import { render, staticRenderFns } from "./agreeText.vue?vue&type=template&id=6e0521ff"
import script from "./agreeText.vue?vue&type=script&lang=js"
export * from "./agreeText.vue?vue&type=script&lang=js"
import style0 from "./agreeText.vue?vue&type=style&index=0&id=6e0521ff&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports